import React from 'react';

const AccountTypeBadge = ({ type }) => {
  const getBadgeProps = (type) => {
    switch (type) {
      case 'Income':
      case 'Other Income':
        return { className: 'type-badge-income', icon: 'fa-arrow-up' };
      case 'Bank':
        return { className: 'type-badge-asset', icon: 'fa-university' };
      case 'Fixed Assets':
        return { className: 'type-badge-asset', icon: 'fa-building' };
      case 'Accounts receivable (A/R)':
        return { className: 'type-badge-asset', icon: 'fa-file-invoice-dollar' };
      case 'Other Current Assets':
      case 'Other Assets':
        return { className: 'type-badge-asset', icon: 'fa-box' };
      case 'Accounts payable (A/P)':
        return { className: 'type-badge-liability', icon: 'fa-file-invoice' };
      case 'Credit Card':
        return { className: 'type-badge-liability', icon: 'fa-credit-card' };
      case 'Other Current Liabilities':
      case 'Long Term Liabilities':
        return { className: 'type-badge-liability', icon: 'fa-hand-holding-usd' };
      case 'Equity':
        return { className: 'type-badge-equity', icon: 'fa-chart-pie' };
      case 'Cost of Goods Sold':
      case 'Expenses':
      case 'Other Expense':
        return { className: 'type-badge-expense', icon: 'fa-arrow-down' };
      default:
        return { className: 'type-badge-expense', icon: 'fa-question-circle' };
    }
  };

  const props = getBadgeProps(type);

  return (
    <div className={`type-badge ${props.className}`}>
      <i className={`fas ${props.icon}`}></i>
      <span>{type === 'Expense' ? 'Expenses' : type}</span>
    </div>
  );
};

export default AccountTypeBadge;
